export default {
  "HitPaw Online Audio Joiner": "HitPaw 온라인 오디오 병합기",
  "Merge Audio": "오디오 병합하기",
  "Merge multiple audio tracks into one.": "여러 오디오 트랙을 하나로 병합합니다.",
  "Merge New": "새로 병합하기",
  "Merge failed": "병합에 실패했습니다.",
  "Fade in": "페이드인",
  "Fade out": "페이드아웃",
  "Add tracks": "트랙 추가",
  "Format": "형식",
};
